import { Fragment, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardFooter,
  Input,
  Button,
  Alert,
  CardBody,
  Collapse,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useQuery, useMutation } from "@apollo/client";
import {
  GET_MESSAGE_AS_CSO,
  GET_MESSAGE_DETAIL_AS_CSO,
  GET_COLLABORATION_STATUS,
} from "../queries";
import { useParams } from "react-router-dom";
import { CSO_SEND_MESSAGE } from "../mutations";
import moment from "moment";
import { Link } from "react-router-dom";
import ModalCreateInvitation from "./ModalCreateInvitation";
import ModalAnswerInvitation from "./ModalAnswerInvitation";
import styles from "./message.module.scss";
import LaddaButton, { ZOOM_OUT } from "react-ladda";

const renderTextWithLineBreaks = (text) => {
  const lines = text.split("\\n");

  return (
    <div>
      {lines.map((line, index) => (
        <Fragment key={index}>
          {line}
          <br />
        </Fragment>
      ))}
    </div>
  );
};

const containsOnlyWhitespace = (text) => {
  return /^\s*$/.test(text);
};

const ChatRoomCSO = () => {
  const params = useParams();
  const { data: dataChat, refetch } = useQuery(GET_MESSAGE_AS_CSO, {
    fetchPolicy: "no-cache",
    variables: { collaborationStatus: params.id },
  });

  const { data: dataMessageDetail } = useQuery(GET_MESSAGE_DETAIL_AS_CSO, {
    fetchPolicy: "no-cache",
    variables: { collaborationStatus: params.id },
  });

  const [messages, setMessages] = useState(null);
  const { data: statusCollaboration, refetch: refetchStatus } = useQuery(
    GET_COLLABORATION_STATUS,
    {
      fetchPolicy: "no-cache",
      variables: { collaborationStatus: params.id },
    }
  );

  const refetchData = async () => {
    await refetch();
    await refetchStatus();
  };

  const [openCreateInvitation, setOpenCreateInvitation] = useState(false);
  const [openAnswerInvitation, setOpenAnswerInvitation] = useState(false);
  const [collapsibleInfo, setCollapsibleInfo] = useState(true);

  const toggle = () => setOpenCreateInvitation(!openCreateInvitation);
  const toggleAnswer = () => setOpenAnswerInvitation(!openAnswerInvitation);

  const handleChange = (e) => {
    setMessages(e.target.value);
  };

  const [sendMessages, { loading: loadingSend }] =
    useMutation(CSO_SEND_MESSAGE);

  const onSendMessage = (e) => {
    if (messages !== null && containsOnlyWhitespace(messages) === false) {
      sendMessages({
        variables: {
          collaborationStatusId: params.id,
          message: messages.replace(/\n/g, "\\n"),
        },
      })
        .then((response) => {
          setMessages("");
          refetch();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <Fragment>
      <Row className="mb-3">
        <Col lg={12}>
          <Card>
            <CardHeader>
              <div className="chat-header-container">
                <div className="responsive-chat-header">
                  <img
                    src={
                      dataChat?.myCollaborationStatusesAsSupporter?.edges[0]
                        .node.supporter.logoUrl
                    }
                    alt="logoSupporter"
                    width={40}
                    height={40}
                    className="img-responsive mr-3"
                  />

                  <h5 className="mr-3 mt-1">
                    {
                      dataChat?.myCollaborationStatusesAsSupporter?.edges[0]
                        .node.supporter.name
                    }
                  </h5>
                  {collapsibleInfo ? (
                    <Button
                      size="sm"
                      className={styles["toggle-btn"]}
                      onClick={() => setCollapsibleInfo(!collapsibleInfo)}
                    >
                      <i className="pe-7s-angle-up-circle"></i>
                      &nbsp; 連携ニーズ
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      outline
                      className={styles["toggle-btn-close"]}
                      onClick={() => setCollapsibleInfo(!collapsibleInfo)}
                    >
                      <i className="pe-7s-angle-down-circle"></i>
                      &nbsp; 連携ニーズ
                    </Button>
                  )}
                </div>

                <div className="btn-actions-pane-right actions-icon-btn">
                  <Link
                    to={`/dashboards/organization-partnership?tabActive=5`}
                    className="btn-icon btn-icon-only mr-3"
                    color="link"
                  >
                    <i className="pe-7s-angle-left-circle btn-icon-wrapper" />{" "}
                    メッセージ一覧へ
                  </Link>
                </div>
              </div>
            </CardHeader>
            <Collapse
              isOpen={collapsibleInfo}
              data-parent="#accordion"
              id="collapseOne"
              aria-labelledby="headingOne"
            >
              <CardBody>
                {dataMessageDetail?.getCollaborationStatus?.edges?.map(
                  (edge) => (
                    <>
                      <b>連携ニーズ </b> <br />
                      {edge.node.collaborationNeeds?.edges?.map((item) => (
                        <>{item.node.title} &nbsp; / &nbsp;</>
                      ))}
                      <br />
                      <br />
                      <b>連携時期</b> <br />
                      {edge.node.idealStartingTime} <br />
                      <br />
                      <b>連携規模</b> <br />
                      {edge.node.collaborationScale} <br />
                      <br />
                    </>
                  )
                )}
              </CardBody>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Card className="main-card mb-3">
            <div className="scroll-area-xl">
              <PerfectScrollbar>
                <div
                  className="chat-wrapper p-1"
                  style={{
                    height: "55vh",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {dataChat?.getMyMessagesAsCso?.edges?.map((edge) => (
                    <>
                      {!edge.node.supporterIsSender ? (
                        <div
                          className="float-right"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div className="chat-box-wrapper chat-box-wrapper-right">
                            <div
                              style={{
                                marginLeft: "48px",
                              }}
                            >
                              <div className="chat-box">
                                {renderTextWithLineBreaks(edge.node.message)}
                              </div>
                              <small className="opacity-6">
                                <FontAwesomeIcon
                                  icon={faCalendarAlt}
                                  className="mr-1"
                                />
                                {moment(
                                  edge?.node?.readAt ?? edge?.node?.createdAt
                                ).format("YYYY-MM-DD HH:mm")}
                              </small>
                            </div>
                            <div>
                              <div className="avatar-icon-wrapper ml-1">
                                {/* <div className="badge badge-bottom btn-shine badge-success badge-dot badge-dot-lg" /> */}
                                <div className="avatar-icon avatar-icon-lg rounded">
                                  <img
                                    src={
                                      edge.node.collaborationStatus.supporter
                                        .logoUrl
                                    }
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="chat-box-wrapper"
                          style={{
                            marginRight: "48px",
                          }}
                        >
                          <div>
                            <div className="avatar-icon-wrapper mr-1">
                              {/* <div className="badge badge-bottom btn-shine badge-success badge-dot badge-dot-lg" /> */}
                              <div className="avatar-icon avatar-icon-lg rounded">
                                <img
                                  src={
                                    edge.node.collaborationStatus.supporter
                                      .logoUrl
                                  }
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className="chat-box">
                              {renderTextWithLineBreaks(edge.node.message)}
                            </div>
                            <small className="opacity-6">
                              <FontAwesomeIcon
                                icon={faCalendarAlt}
                                className="mr-1"
                              />
                              {moment(
                                edge?.node?.readAt ?? edge?.node?.createdAt
                              ).format("YYYY-MM-DD HH:mm")}
                            </small>
                          </div>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              </PerfectScrollbar>

              {(statusCollaboration?.getCollaborationStatus?.edges[0].node
                .csoStatus === "NEW_CONTACT" ||
                statusCollaboration?.getCollaborationStatus?.edges[0].node
                  .csoStatus === "IN_CONTACT") && (
                <>
                  <div className="divider"></div>
                  <div className="pull-right mr-4 mb-4">
                    <Button color="focus" size="md" onClick={toggle}>
                      この組織と面談する
                    </Button>
                  </div>
                </>
              )}
              {statusCollaboration?.getCollaborationStatus?.edges[0].node
                .csoStatus === "REPLY" && (
                <>
                  {/* <div className="divider"></div> */}
                  <div className="text-center">
                    <Alert
                      className="mbg-3 text-center ml-4 mr-4 pt-3 pb-3"
                      style={{
                        backgroundColor: "#FFD5D5",
                        color: "#000000",
                        border: "none",
                      }}
                      isOpen={
                        statusCollaboration?.getCollaborationStatus?.edges[0]
                          .node.csoStatus === "REPLY" && true
                      }
                    >
                      面談依頼に返答してください
                    </Alert>
                    <Button
                      size="xl"
                      style={{
                        backgroundColor: "#44CAE1",
                        borderColor: "#44CAE1",
                        border: "none",
                      }}
                      className="mb-3 pt-3 pb-3 pl-5 pr-5"
                      onClick={toggleAnswer}
                    >
                      面談依頼に返答する
                    </Button>
                  </div>
                </>
              )}

              {statusCollaboration?.getCollaborationStatus?.edges[0].node
                .csoStatus === "IN_INVITE" && (
                <>
                  <div className="divider"></div>
                  <div className="text-center">
                    <Alert
                      className="mbg-3 text-center ml-4 mr-4 pt-3 pb-3"
                      // color="info"
                      style={{
                        backgroundColor: "#FFD5D5",
                        color: "#000000",
                        border: "none",
                      }}
                      isOpen={
                        statusCollaboration?.getCollaborationStatus?.edges[0]
                          .node.csoStatus === "IN_INVITE" && true
                      }
                    >
                      面談依頼中
                    </Alert>
                  </div>
                </>
              )}

              {statusCollaboration?.getCollaborationStatus?.edges[0].node
                .csoStatus === "HAVE_INERVIEW" && (
                <>
                  <div className="divider"></div>
                  <div className="text-center">
                    <Alert
                      className="mbg-3 text-center ml-4 mr-4 pt-3 pb-3"
                      // color="info"
                      style={{
                        backgroundColor: "#FFD5D5",
                        color: "#000000",
                        border: "none",
                      }}
                      isOpen={
                        statusCollaboration?.getCollaborationStatus?.edges[0]
                          .node.csoStatus === "HAVE_INERVIEW" && true
                      }
                    >
                      面談予定
                    </Alert>
                  </div>
                </>
              )}

              {statusCollaboration?.getCollaborationStatus?.edges[0].node
                .csoStatus === "IS_DONE" && (
                <>
                  <div className="text-center">
                    <Alert
                      className="mbg-3 text-center ml-4 mr-4 pt-3 pb-3"
                      // color="info"
                      style={{ backgroundColor: "#495057", color: "#ffffff" }}
                      isOpen={
                        statusCollaboration?.getCollaborationStatus?.edges[0]
                          .node.csoStatus === "IS_DONE" && true
                      }
                    >
                      この連携セッションは終了しました
                    </Alert>
                  </div>
                </>
              )}
            </div>
            {statusCollaboration?.getCollaborationStatus?.edges[0].node
              .csoStatus !== "IS_DONE" && (
              <CardFooter>
                {statusCollaboration?.getCollaborationStatus?.edges[0].node
                  .csoStatus !== "NEW_CONTACT" &&
                  statusCollaboration?.getCollaborationStatus?.edges[0].node
                    .csoStatus !== "REPLY" &&
                  statusCollaboration?.getCollaborationStatus?.edges[0].node
                    .csoStatus !== "IS_DONE" &&
                  statusCollaboration?.getCollaborationStatus?.edges[0].node
                    .csoStatus !== "IN_INVITE" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "end",
                        width: "100%",
                      }}
                    >
                      <Input
                        bsSize="lg"
                        type="textarea"
                        name="messages"
                        rows={3}
                        value={messages}
                        onChange={handleChange}
                        // onKeyDown={onSendMessage}
                        placeholder="メッセージを入力する"
                        className="w-full"
                        disabled={loadingSend}
                      />
                      {!loadingSend ? (
                        <button
                          style={{
                            height: "48px",
                            border: "none",
                            marginLeft: "12px",
                            padding: "0 20px",
                            minWidth: "100px",
                            backgroundColor:
                              messages === null ||
                              containsOnlyWhitespace(messages)
                                ? "gray"
                                : "#000",
                            color: "white",
                            borderRadius: "5px",
                            cursor: "pointer",
                            marginBottom: "16px",
                          }}
                          disabled={
                            messages === null ||
                            containsOnlyWhitespace(messages)
                          }
                          onClick={() => onSendMessage(messages)}
                        >
                          送る
                        </button>
                      ) : (
                        <LaddaButton
                          className="btn btn-info"
                          style={{
                            backgroundColor: "#44CAE1",
                            borderColor: "#44CAE1",
                            height: "48px",
                            border: "none",
                            marginLeft: "12px",
                            padding: "0 20px",
                            minWidth: "100px",
                            marginBottom: "16px",
                          }}
                          loading={true}
                          data-style={ZOOM_OUT}
                          disabled
                        >
                          送信
                        </LaddaButton>
                      )}
                    </div>
                  )}
              </CardFooter>
            )}
          </Card>
        </Col>
      </Row>
      {openCreateInvitation && (
        <ModalCreateInvitation
          open={openCreateInvitation}
          setOpenCreateInvitation={setOpenCreateInvitation}
          refetchStatus={() => {
            refetchData();
          }}
        />
      )}

      {openAnswerInvitation && (
        <ModalAnswerInvitation
          open={openAnswerInvitation}
          setOpenAnswerInvitation={setOpenAnswerInvitation}
          refetchStatus={refetchData}
        />
      )}
    </Fragment>
  );
};

export default ChatRoomCSO;
